import { Feature, MapFeature, useMapStore } from "../store";
import { createCountText, createGuid, getPinForImage, getDetails, getMessage, getTitle } from '../mapUtils'
import { ReactNode, useMemo } from "react";
import DynamicAccordion from "./DynamicAccordion";

interface MarkerAccordionProps {
  reportFormUrl: string;
  handleOpenInfowindow: (id: number) => void;
}

const MarkerAccordion = ({ reportFormUrl, handleOpenInfowindow }: MarkerAccordionProps) => {
  const { visibleFeatures, searchPlace } = useMapStore();
  const items = useMemo(() => {
    let suburbs: Record<string, Array<MapFeature['properties'] & {key: number}>> = {}
    if (visibleFeatures) {
      visibleFeatures.forEach(({ key, data }) => {
        data.affected_suburbs.forEach((suburb: string) => {
          if (suburb in suburbs) {
            suburbs[suburb].push({...data, key})
          } else {
            suburbs[suburb] = [{...data, key}]
          }
        })
      })
    }
    let suburbArray = Object.entries(suburbs).map(([suburb, array]) => {
      let title = suburb
      let count = {
        Active: 0,
        Completed: 0,
        Registered: 0,
        Major: 0,
        Closed: 0
      }
      let content: Array<ReactNode> = []
      array.forEach((x) => {
        count[x.status] += 1
        content.push(
          <AccordionContent data={x} markerKey={x.key} handleOpenInfowindow={handleOpenInfowindow} />
        )
      });
      let subtitle = createCountText(count)
      return { title, subtitle, content }
    })
    return suburbArray.sort((a, b) => {
      return a.title.localeCompare(b.title);
    })
  }, [visibleFeatures])

  if(!items.length && searchPlace) {
    return <NoResults reportFormUrl={reportFormUrl} searchPlace={searchPlace} />
  }

  return (
    <DynamicAccordion items={items} />
  );
};


type AccordionContent = {
  markerKey: number;
  data: Feature["data"];
  handleOpenInfowindow: (id: number) => void;
}

const AccordionContent = ({ data, markerKey, handleOpenInfowindow }: AccordionContent) => {
  const title = data.status === 'Major' ? data.name : getTitle(data.status)
  // Function to move the map to marker location
  return (
    <div key={createGuid()} className="flex">
      <div className="flex-none mr-4">
        <img src={getPinForImage(data.status)}  alt={`${data.status} pin`} />
      </div>
      <div>
        <h6 className="h6 mt-4 text-ocean">{title}</h6>
        <p>{getMessage(data.planned_flag === "True")}</p>
        <p className="mb-0">{getDetails(data)}</p>
        <button
          className="link text-body mt-2"
          data-markerlink
          onClick={() => {
            handleOpenInfowindow(markerKey)
          }}
        >
          View on map
        </button>
      </div>
    </div>
  )
}

const NoResults = ({reportFormUrl, searchPlace}: {reportFormUrl: string; searchPlace: string;}) => {
  return (
    <div className="transition-opacity duration-500 pl-4">
      <h5>{searchPlace}</h5>
      <h6>There are no known outages at this address</h6>
      <p>If you are experiencing a water outage at this address, please report the outage to one of our 24 hour support crew, so we can investigate. <br />
        <a href={reportFormUrl}>Report a fault</a>
      </p>
    </div>
  )
}

export default MarkerAccordion;
